export const FILTER_WASTE_REQUEST = 'FILTER_WASTE_REQUEST'
export const FILTER_WASTE_SUCCESS = 'FILTER_WASTE_SUCCESS'
export const FILTER_WASTE_FALUIRE = 'FILTER_WASTE_FALUIRE'
